
export default {
  data() {
    return {};
  },
  props: {
    visible: {//是否可见
      type: Boolean,
      default: false
    },
    multiple: {//允许多选
      type: Boolean,
      default: true
    },
    userKeys:Array,//默认选中的用户列表
    orgKey: String,//指定机构，如果指定该参数，则仅仅加载该机构及其子机构,
    orgCode:String, //指定机构，如果指定该参数，则仅仅加载该机构及其子机构
  },
  watch: {
      visible(){
          const me = this, picker=me.$refs['user-picker'];
          if(me.visible){
              picker.initSelection();
          }
      }
  },
  methods: {
      cancel(){
          const me = this;
          me.close();
      },
      shClose(){//关闭时激活
          const me = this, picker=me.$refs['user-picker'];
          me.$emit('callback', picker.getUsers(), picker.getUserObj());
          me.$emit('selected', picker.getUsers(), picker.getUserObj());
      },
      close(){
          const me = this;
          me.$emit('callback', null);
          me.$emit('close');
      },
  }
};


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/user/dialog/src/dialog.js